export default __webpack_public_path__ + "static/media/1.6a3d55d0.png";